module.exports = __webpack_public_path__ + "static/media/afro-latin-america-george-reid-andrews.3c68fe15.jpg";